/**
 * Shared button primitive. Maps variant to the existing App.css .btn classes.
 *
 * Three-tier hierarchy:
 *   primary  — solid gold gradient, the one main action per screen
 *   outline  — amber, secondary affirmative actions
 *   ghost    — low-emphasis inline / minor actions
 * Plus: secondary (neutral default), danger (destructive).
 *
 * variant: 'primary' | 'outline' | 'ghost' | 'secondary' | 'danger'  (default: 'secondary')
 * size:    'sm' | 'md'                                                 (default: 'md')
 *
 * All other props (type, onClick, disabled, title, aria-*) pass through.
 */
const VARIANT_CLASSES = {
  primary:   'btn-primary',
  outline:   'btn-outline',
  ghost:     'btn-ghost',
  danger:    'btn-danger',
  secondary: 'btn-secondary',
};

export default function Button({ variant = 'secondary', size, className = '', children, ...props }) {
  const variantClass = VARIANT_CLASSES[variant] || VARIANT_CLASSES.secondary;

  const sizeClass = size === 'sm' ? 'btn-sm' : '';

  const classes = ['btn', variantClass, sizeClass, className].filter(Boolean).join(' ');

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
